enum CMS {
  WORDPRESS = 'WordPress',
  WOOCOMMERCE = 'WooCommerce',
  BIGCOMMERCE = 'BigCommerce',
  SQUARE = 'Square',
  WIX = 'Wix',
  WEBFLOW = 'WebFlow',
  PRESTASHOP = 'PrestaShop',
  MAGENTO = 'Magento',
  LIGHTSPEED = 'LightSpeed',
  JOOMLA = 'Joomla',
}

const CMS_WITH_LIMITED_ACCESS_MODE = [
  CMS.WORDPRESS as string,
  CMS.WOOCOMMERCE as string,
  CMS.WIX as string,
  CMS.BIGCOMMERCE as string,
  CMS.SQUARE as string,
  CMS.WEBFLOW as string,
  CMS.PRESTASHOP as string,
  CMS.MAGENTO as string,
  CMS.LIGHTSPEED as string,
  CMS.JOOMLA as string,
];

const CMS_NEED_DOMAIN_VERIFICATION_FOR_LAM = [
  CMS.WORDPRESS as string,
  CMS.WOOCOMMERCE as string,
  CMS.PRESTASHOP as string,
  CMS.MAGENTO as string,
  CMS.JOOMLA as string,
];

const CMS_WITH_CMSCONTEXT = [
  CMS.BIGCOMMERCE as string,
  CMS.SQUARE as string,
  CMS.WIX as string,
  CMS.WEBFLOW as string,
  CMS.LIGHTSPEED as string,
];
const AutomatedCMS = [CMS.WORDPRESS as string];

const CMS_WITH_USER_FEEDBACK = [
  CMS.WORDPRESS as string,
  CMS.WOOCOMMERCE as string,
  CMS.BIGCOMMERCE as string,
  CMS.SQUARE as string,
  CMS.WIX as string,
  CMS.WEBFLOW as string,
  CMS.PRESTASHOP as string,
  CMS.MAGENTO as string,
  CMS.LIGHTSPEED as string,
  CMS.JOOMLA as string,
];

const CMS_RATING_URL: Record<string, string | ((storeId: string) => string)> = {
  [CMS.WORDPRESS]:
    'https://wordpress.org/support/plugin/accessibe/reviews/?filter=5',
  [CMS.WOOCOMMERCE]: 'https://woocommerce.com/products/accessibe/',
  [CMS.BIGCOMMERCE]:
    'https://www.bigcommerce.com/apps/web-accessibility-by-accessibe/',
  [CMS.SQUARE]:
    'https://squareup.com/us/en/app-marketplace/app/web-accessibility?tab=reviews',
  [CMS.WIX]: 'https://www.wix.com/app-market/web-solution/accessibe',
  [CMS.WEBFLOW]: 'https://webflow.com/apps/detail/accessibe',
  [CMS.PRESTASHOP]:
    'https://addons.prestashop.com/en/website-audit-optimization/96557-accessibe-web-accessibility.html',
  [CMS.MAGENTO]:
    'https://commercemarketplace.adobe.com/accessibe-accesswidget.html',
  [CMS.LIGHTSPEED]: (storeId: string) =>
    `https://ecom.lightspeed.app/store/${storeId}#apps:view=app&name=accessibe`,
  [CMS.JOOMLA]:
    'https://extensions.joomla.org/extension/web-accessibility-and-compliance/',
};

const PLUGINSOURCE_PAYMENT_MANAGED_ON_CMS = [
  CMS.WOOCOMMERCE as string,
  CMS.WIX as string,
];

const CMS_WITH_CALENDLY_POPUP = [
  CMS.WORDPRESS as string,
  CMS.WOOCOMMERCE as string,
  CMS.BIGCOMMERCE as string,
  CMS.SQUARE as string,
  CMS.WIX as string,
  CMS.WEBFLOW as string,
  CMS.PRESTASHOP as string,
  CMS.MAGENTO as string,
  CMS.LIGHTSPEED as string,
  CMS.JOOMLA as string,
];

const CMS_WITH_NO_EMAIL_SIGNUP = [
  // CMS.SQUARE as string,
  CMS.BIGCOMMERCE as string,
  CMS.WIX as string,
  CMS.WEBFLOW as string,
  CMS.LIGHTSPEED as string,
];
const CMS_CUSTOM_DISCOUNTS = {
  [CMS.SQUARE as string]: 20,
};

const VISIT_THRESHOLD_LIMIT = 30000;

export {
  CMS,
  AutomatedCMS,
  CMS_WITH_LIMITED_ACCESS_MODE,
  CMS_NEED_DOMAIN_VERIFICATION_FOR_LAM,
  CMS_WITH_CMSCONTEXT,
  CMS_RATING_URL,
  CMS_WITH_USER_FEEDBACK,
  PLUGINSOURCE_PAYMENT_MANAGED_ON_CMS,
  CMS_WITH_CALENDLY_POPUP,
  CMS_WITH_NO_EMAIL_SIGNUP,
  CMS_CUSTOM_DISCOUNTS,
  VISIT_THRESHOLD_LIMIT,
};
